import {
  CustomerModel, PartnerShopModel, UserModel, FileModel,
  PartnerProductModel, ShippingAddressModel, BillingAddressModel, 
  PartnerProductCouponModel, PartnerShippingFrontendModel, PartnerShippingCouponModel,
  CustomerOrderModel, CustomerCart2C2PModel,
  PartnerProductGiveawayRuleModel,
} from '.';
import { unescape } from 'html-escaper';
import { translate } from '../helpers/frontend';

/*
  status : Number
    0 = Rejected
    1 = Draft
    1.5 = Customer Draft
    2 = In Progress
    3 = Approved
    4 = Completed
*/

export class ToolCustomerQuotationModel {
  constructor(data={}) {
    this._id = data._id || null;

    this.channel = data.channel || 'C2U';
    
    this.customer = new CustomerModel(data.customer || {});
    this.shop = new PartnerShopModel(data.shop || {});
    this.salesManager = new UserModel(data.salesManager || {});
    
    this.order = new CustomerOrderModel(data.order || {});
    this.cart2C2P = new CustomerCart2C2PModel(data.cart2C2P || {});
    this.paymentUrl = data.paymentUrl || '';

    this.code = data.code || '';
    this.title = Number(data.title || 0);
    this.header = Number(data.header || 1);
    
    this.date = data.date || null;
    this.expiredDate = data.expiredDate || null;

    this.type = Number(data.type || 0);
    this.typeDescription = data.typeDescription || '';
    this.typeDescription = {
      value: Number(data.typeDescription?.value || 0),
      label: String(data.typeDescription?.label || ''),
    };
    this.paymentTerm = data.paymentTerm || '';

    this.products = data.products?.length? data.products.map(d => new PartnerProductModel(d)): [];
    this.productGiveawayRule = new PartnerProductGiveawayRuleModel(data?.productGiveawayRule ?? {});
    
    this.subtotal = data.subtotal || data.subtotal===0? Number(data.subtotal): null;
    this.vatName = data.vatName? unescape(data.vatName): '';
    this.vat = data.vat || data.vat===0? Number(data.vat): null;
    this.vatPercent = data.vatPercent || data.vatPercent===0? Number(data.vatPercent): null;
    
    this.total = data.total || data.total===0? Number(data.total): null;
    this.hasDownPayment = data.hasDownPayment? Number(data.hasDownPayment): 0;
    this.downPayment = data.downPayment? Number(data.downPayment): 0;
    this.missingPayment = data.missingPayment? Number(data.missingPayment): 0;
    
    this.status = Number(data.status ?? 1);
    this.history = !data.history?.length? [] 
      : data.history.map(d => ({
        status: Number(d.status ?? 1),
        createdAt: d.createdAt || null,
        createdBy: new UserModel(d.createdBy || {}),
        note: d.note? unescape(d.note): '',
        files: d.files?.length? d.files.map(k => new FileModel(k)): [],
        displayStatus(langObj={}){
          if(this.status === 4) return (<span className="ss-tag bg-success">{translate('Completed', langObj)}</span>);
          if(this.status === 3) return (<span className="ss-tag bg-info">{translate('Approved', langObj)}</span>);
          if(this.status === 2) return (<span className="ss-tag bg-warning">{translate('In Process', langObj)}</span>);
          if(this.status === 1.5) return (<span className="ss-tag bg-default">{translate('Customer Draft', langObj)}</span>);
          if(this.status === 1) return (<span className="ss-tag bg-default">{translate('Draft', langObj)}</span>);
          if(this.status === 0) return (<span className="ss-tag bg-danger">{translate('Rejected', langObj)}</span>);
          return (<></>);
        },
      }));

    this.shippingAddress = new ShippingAddressModel(data.shippingAddress || {});
    this.billingAddress = new BillingAddressModel(data.billingAddress || {});

    this.couponFrontend = new PartnerProductCouponModel(data.couponFrontend || {});
    this.shippingFrontend = new PartnerShippingFrontendModel(data.shippingFrontend || {});
    this.shippingCouponFrontend = new PartnerShippingCouponModel(data.shippingCouponFrontend || {});
    this.cashCouponFrontend = new PartnerProductCouponModel(data.cashCouponFrontend || {});
    this.selectedPoints = {
      points: Number(data.selectedPoints?.points || 0),
      discount: Number(data.selectedPoints?.discount || 0),
    };

    this.grandTotal = data.grandTotal || data.grandTotal===0? Number(data.grandTotal): null;
    
    this.note = data.note || '';

    this.createdAt = data.createdAt || null;
    this.createdBy = new UserModel(data.createdBy || {});
    this.updatedAt = data.updatedAt || null;
    this.updatedBy = new UserModel(data.updatedBy || {});
  }

  isValid() {
    return this._id? true: false;
  }

  displayStatus(langObj={}) {
    if(!this.isValid()) return (<></>);
    if(this.status === 4) return (<span className="ss-tag bg-success">{translate('Completed', langObj)}</span>);
    if(this.status === 3) return (<span className="ss-tag bg-info">{translate('Approved', langObj)}</span>);
    if(this.status === 2) return (<span className="ss-tag bg-warning">{translate('In Process', langObj)}</span>);
    if(this.status === 1.5) return (<span className="ss-tag bg-default">{translate('Customer Draft', langObj)}</span>);
    if(this.status === 1) return (<span className="ss-tag bg-default">{translate('Draft', langObj)}</span>);
    if(this.status === 0) return (<span className="ss-tag bg-danger">{translate('Rejected', langObj)}</span>);
    return (<></>);
  }
  displayType(langObj={}) {
    if(this.type === 1) return translate('โชว์รูม', langObj);
    if(this.type === 2) return translate('งานแสดงสินค้า', langObj);
    if(this.type === 3) return translate('อื่นๆ', langObj);
    return '';
  } 

  hasVAT() {
    if(this.vat && this.vat > 0 && this.vatPercent && this.vatPercent > 0) return true;
    return false;
  }

  hasShipBySupplier() {
    let shipBySupplier = false;
    this.products.forEach(d => { if(d.shipBySupplier) shipBySupplier = true; });
    return shipBySupplier;
  }
  shipBySupplierProducts() {
    return this.products.filter(d => d.shipBySupplier);
  }
}